'use client';

import { isProd } from '@/common';
import { useIsMounted } from './useIsMounted';

/**
 * Returns true when running in production, false otherwise.
 * Defaults to true before hydration so that !isProd blocks are never rendered
 * server-side or during the first client paint — eliminating the flash on prod.
 */
export const useIsProd = (): boolean => {
  const isMounted = useIsMounted();
  return isMounted ? isProd : true;
};
